import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../assets/header.png'


const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "header flex justify-center p-2" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "/" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "logo",
      src: _imports_0
    })
  ])
], -1)
const _hoisted_3 = { class: "flex flex-row justify-center gap-2 md:flex-row" }
const _hoisted_4 = {
  key: 0,
  class: "loggedIn"
}
const _hoisted_5 = {
  key: 1,
  class: "guest"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Blogs = _resolveComponent("Blogs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("nav", _hoisted_3, [
      (_ctx.loggedUser)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_router_link, {
              class: "text-link-color text-lg font-bold cursor-pointer mx-1 hover:text-gray-500",
              to: {name:'add-article'}
            }, {
              default: _withCtx(() => [
                _createTextVNode("Add Article")
              ]),
              _: 1
            }),
            _createElementVNode("span", {
              class: "text-link-color text-lg font-bold cursor-pointer mx-1 hover:text-gray-500",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.signout && _ctx.signout(...args)))
            }, "Sign out")
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_router_link, {
              class: "text-link-color text-lg font-bold cursor-pointer mx-1 hover:text-gray-500",
              to: {name:'login'}
            }, {
              default: _withCtx(() => [
                _createTextVNode("Login")
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              class: "text-link-color text-lg font-bold cursor-pointer mx-1 hover:text-gray-500",
              to: {name:'register'}
            }, {
              default: _withCtx(() => [
                _createTextVNode("Register")
              ]),
              _: 1
            })
          ]))
    ]),
    _createVNode(_component_Blogs, { onError: _ctx.showError }, null, 8, ["onError"])
  ]))
}